export enum FileGuardOperation {
  Delete = 'delete',
  Rename = 'rename'
}
